<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">Add notes for {{ name }}</div>
                <div class="box-search">
                    <button
                        class="box-search-btn"
                        type="submit"
                        @click="getListOfNotes"
                    ><img src="/img/svg/icons-search.svg" alt="">
                    </button>
                    <input
                        type="search"
                        class="box-search-txt"
                        v-model="filters.search"
                        @input="handleSearch"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Notes</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="newComment"
                        ></textarea>
                    </div>
                </div>
                <div class="col-md-12">
                    <h6>History</h6>
                    <div class="history-messages">
                        <div class="text-scroll">
                            <div class="todo-comments-block">

                                <div class="comment-item"
                                     v-for="comment in listOfNotesOnUser"
                                     :key="comment.id"
                                >
                                    <div
                                        class="avatar"
                                        :style="{'background-image': comment.author.avatar ? getNameOfAvatar(comment.author.avatar): `url(/img/svg/emptyAvatar.png)`}">
                                    </div>
                                    <div class="item-inner">

                                        <div class="date-time"
                                             v-if="comment.updated_at">
                                            {{ formatDate(comment.updated_at) }}
                                        </div>
                                        <div class="date-time" v-else>{{ formatDate(comment.created_at) }}</div>

                                        <div class="item-inner-content">
                                            <div class="item-inner-content-text">
                                                <div class="item-ttl">
                                                    <h5>{{ comment.author.name }} {{ comment.author.last_name }}</h5>
                                                </div>
                                                <div class="form-group form-group-1 mb-0"
                                                     v-if="activeComment.id === comment.id"
                                                >
                                                                <textarea
                                                                    type="text"
                                                                    v-model="comment.comment"
                                                                    class="form-control">

                                                                </textarea>
                                                </div>
                                                <p v-else>
                                                    <pre style="white-space: pre-wrap; font-family: 'Open Sans', sans-serif; font-size: 14px;">{{ comment.comment }}</pre>
                                                </p>
                                            </div>
                                            <div class="action-block">
                                                <a href="javascript:void(0)"
                                                   v-if="activeComment.id === comment.id"
                                                   class="img-btn edit-link ml-2"
                                                   @click="saveComment(comment)"
                                                ><img src="/img/svg/check-5.svg" alt="save"></a>

                                                <a href="javascript:void(0)"
                                                   v-else
                                                   class="img-btn edit-link ml-2"
                                                   @click="editComment(comment)"
                                                ><img src="/img/svg/icons-pen.svg" alt="edit"></a>
                                                <button
                                                    v-show="activeComment.id !== comment.id"
                                                    class="img-btn delete-link"
                                                    @click="showDeleteModal(comment.id, 'notesOnAdmin')"
                                                ><img src="/img/svg/on.svg" alt=""></button>
                                                <ActionModal confirm-text="Yes"
                                                             reject-text="No"
                                                             :modalId="getDeleteModalId(comment.id, 'notesOnAdmin')"
                                                             @confirm="deleteComment(comment.id)">
                                                    <template #body>
                                                        <div class="text-center mb-4">
                                                            <h4>
                                                                Are you sure you want <br> to delete this item?
                                                            </h4>
                                                        </div>
                                                    </template>
                                                </ActionModal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns-wrap mt-4">
                <button @click="reloadPage" class="btn btn--outline-primary w-100 w-sm-auto">Cancel</button>
                <button @click="addNewComment" class="btn btn--secondary w-100 w-sm-auto">Save</button>
            </div>
        </div>
    </div>

</template>

<script>

import UsersServices from "../services/UsersServices";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";
import {createDebouncedFunction} from "../../../../../../resources/js/plugins/debounce";

export default {
    name: 'NotesOnAdmin',
    components: {ActionModal},
    mixins: [DateConverter, ModalHandler, StyleHandler],
    props: {
        id: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            newComment: null,
            activeComment: {},
            loading: true,
            listOfNotesOnUser: [],
            filters: {
                search: ''
            },
        }
    },
    methods: {
        async getListOfNotes() {
            try {
                const {data: response} = await UsersServices.getListOfNotesOnAdmin(this.id, this.filters)
                this.listOfNotesOnUser = response
                this.loading = false
            } catch (e) {
            }
        },
        async addNewComment() {
            if (!this.newComment || this.newComment.trim() === '') {
                this.$showErrorMessage('The comment is empty');
            } else {
                this.$showLoadingMessage()
                try {
                    await UsersServices.addNewComment(this.id, this.newComment)
                    await this.getListOfNotes()
                    this.newComment = ''
                    this.$showSuccessMessage('New comment was added')
                } catch (e) {
                    this.$showErrorMessage('New comment was not added. Please try again');
                }
            }
        },
        async deleteComment(id) {
            this.$showLoadingMessage();
            this.listOfNotesOnUser = this.listOfNotesOnUser.filter((comment) => comment.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await UsersServices.deleteComment(id)
            } catch (error) {
                this.$showErrorMessage('The comment was not deleted. Please try again');
            }
        },
        async saveComment(comment) {
            if (!comment.comment || !comment.id || comment.comment.trim() === '') {
                this.$showErrorMessage('The comment is empty');
            } else {
                this.$showLoadingMessage()
                try {
                    await UsersServices.updateComment(comment.id, comment.comment);
                    this.activeComment = {}
                    this.$showSuccessMessage('Your Comment was updated!')
                } catch (e) {
                    this.$showErrorMessage('New comment was not updated. Please try again');
                }
            }
        },
        editComment(comment) {
            this.activeComment = comment
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getListOfNotes()
    }
}

</script>


<style scoped>

</style>
